<section class="user-profile-publications-subpage profile-section"
         [class.mobile]="deviceService.isMobile()"
         [class.tablet]="deviceService.isTablet()">
  <app-title [title]="'user-profile.tab-publications'"></app-title>
  <ng-template [ngIf]="isMe">
    <div class="feed-form">
      <app-feed-post-form (posted)="onContentPosted()"></app-feed-post-form>
    </div>
  </ng-template>

  <ng-template [ngIf]="!isMe && publications.loaded && publications.pagination.total === 0">
    <section class="no-info-section">
      <div class="no-info">{{ 'user-profile.no-publications' | translate }}</div>
    </section>
  </ng-template>

  <ng-template ngFor let-item [ngForOf]="publications.items" let-i="index" [ngForTrackBy]="trackContentByFn">
    <section class="section">
      <app-content-card [item]="item" [inline]="false" [cut]="true"></app-content-card>
    </section>
  </ng-template>

</section>

<app-pagination
  [enabled]="publications.loaded"
  [loading]="publications.loading"
  [pagination]="publications.pagination"
  baseUrl=""
  (nextPage)="onPublicationsNextPage()">
</app-pagination>
